import axios from 'axios'

const Co2Api = axios.create({
    baseURL: co2_form_info.siteUrl + "/wp-json/co2-form/v1/",
});

export default Co2Api; 